import { useMemo } from 'react';
import { TABLE_SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { DoubleArrow } from 'ui/icons/navigation/DoubleArrow';
import { HelpTooltip } from 'ui/tooltip/Variants';
import { colors } from 'ui/theme/colors';

import {
  GoalColumnHeaderColorDown,
  GoalColumnHeaderColorUp,
  GoalColumnHoverIconButton,
  GoalColumnLeftAlignedHeaderCell,
  TableHeaderWithMoreInfo,
  MoreInfoHeaderCell,
} from './Styled';

type Props = {
  name: string;
  value: string;
  sortDirection: string;
  sortedBy: string;
  setSortDirection: (newSortDirection: string) => void;
  setSortedBy: (newSortDirection: string) => void;
  toggleTipContent: string | React.ReactNode;
};

const getArrowIcon = (isActiveSort: boolean, sortDirection: string) => {
  if (!isActiveSort) {
    return <DoubleArrow isColorInherited={true} color={colors.textDisabled} />;
  } else {
    return sortDirection === TABLE_SORT_DIRECTIONS.ASCENDING ? (
      <GoalColumnHeaderColorUp />
    ) : (
      <GoalColumnHeaderColorDown />
    );
  }
};

export const ModelDetailColumnHeader = ({
  value,
  name,
  sortedBy,
  setSortedBy,
  sortDirection,
  setSortDirection,
  toggleTipContent,
}: Props) => {
  const isActiveSort = useMemo(() => value === sortedBy, [sortedBy, value]);

  const handleClick = () => {
    if (isActiveSort) {
      const newSortDirection =
        sortDirection === TABLE_SORT_DIRECTIONS.ASCENDING
          ? TABLE_SORT_DIRECTIONS.DESCENDING
          : TABLE_SORT_DIRECTIONS.ASCENDING;
      setSortDirection(newSortDirection);
      setSortedBy(value);
    } else {
      setSortedBy(value);
    }
  };
  return (
    <TableHeaderWithMoreInfo>
      <MoreInfoHeaderCell>
        <GoalColumnLeftAlignedHeaderCell
          data-is-active-sort={isActiveSort}
          key={value}
          columnData={{ name, align: 'flex-start' }}
          handleClick={handleClick}
          sortable={false}
        />
        <HelpTooltip
          tooltipContent={toggleTipContent}
          iconProps={
            isActiveSort
              ? {
                  color: colors.brandPurple,
                }
              : {
                  color: colors.textSecondary,
                }
          }
        />
        <GoalColumnHoverIconButton onClick={handleClick}>
          {getArrowIcon(isActiveSort, sortDirection)}
        </GoalColumnHoverIconButton>
      </MoreInfoHeaderCell>
    </TableHeaderWithMoreInfo>
  );
};
